import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=a1b984b8&scoped=true"
import script from "./CookieBox.vue?vue&type=script&lang=js"
export * from "./CookieBox.vue?vue&type=script&lang=js"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=a1b984b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b984b8",
  null
  
)

export default component.exports